import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-completa-staff-import-confirmation-modal',
    templateUrl: './completa-staff-import-confirmation-modal.component.html',
    styleUrls: ['./completa-staff-import-confirmation-modal.component.scss'],
    standalone: false
})
export class CompletaStaffImportConfirmationModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CompletaStaffImportConfirmationModalComponent>) { }

  ngOnInit(): void {
  }

  setUserPreference(no: number){
    this.dialogRef.close(no);
  }
}
